import request from './index'

export async function login(username, password) {
  return request.post('/auth/login', {
    username, password
  })
}

export async function getUserInfo() {
  return request.get('/user/info')
}

export async function updateUserInfo(payload) {
  return request.post('/user/update', payload)
}

export async function updatePassword(oldPassword, newPassword) {
  return request.post('/user/update-password', { oldPassword, newPassword })
}


/**
 * ADMIN API BELOW
 */

export async function getUserList() {
  return request.get('/admin/user/list')
}